import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import Check from '@mui/icons-material/Check';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { Container } from './styles';
import { COLORS } from '../../../../values/colors';
import DialogContainer from '../DialogContainer/DialogContainer';


const pdfFile = require('../../../../data/documents/Antrag-zur-Aufnahme-in-die-Eckenmoorhexen-Sulgen.pdf');

const steps = ['Bewerbungsformular herunterladen', 'Bewerbungsformular ausfüllen', 'Bewerbung abschicken'];

function downloadApplicationForumular() {
  window.open(pdfFile, '_blank');
}

const DialogContainerProps = [
  {
    step: '1. Schritt',
    heading: 'Bewerbungsformular herunterladen',
    content: 'Wenn du Interesse hast, Mitglied bei den Eckenmoorhexen zu werden, kannst du hier das Bewerbungsformular bequem über den Download-Button herunterladen. Alle wichtigen Informationen zur Mitgliedschaft findest du darin. Lade es dir herunter und erfahre, wie du Teil unserer Gemeinschaft werden kannst.',
    hasButton: true,
    onButtonClick: downloadApplicationForumular,
  },
  {
    step: '2. Schritt',
    heading: 'Bewerbungsformular ausfüllen',
    content: 'Nachdem du das Bewerbungsformular heruntergeladen hast, kannst du es in Ruhe ausfüllen. Nimm dir Zeit, die Angaben sorgfältig zu machen und alle wichtigen Informationen einzutragen. So hilfst du uns, ein vollständiges Bild von dir zu bekommen. Sobald du fertig bist, kannst du das Formular einfach an uns zurücksenden. Wir freuen uns darauf, dich kennenzulernen!',
    hasButton: false,
  },
  {
    step: '3. Schritt',
    heading: 'Bewerbung abschicken',
    content: 'Sobald du das Bewerbungsformular vollständig ausgefüllt hast, kannst du es einfach per E-Mail an uns senden. Hänge das Dokument an und schicke es an <a href="mailto:info@eckenmoorhexen.de">info@eckenmoorhexen.de</a>. Wir wird sich schnellstmöglich bei dir melden, um die nächsten Schritte zu besprechen. Wir freuen uns auf deine Bewerbung und darauf, dich vielleicht bald als neues Mitglied der Eckenmoorhexen begrüßen zu dürfen!',
    hasButton: false,
  },
]

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: COLORS.apronBrown,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: COLORS.apronBrown,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: COLORS.inactive,
    borderWidth: 3,
    borderRadius: 1,
    position: 'relative', 
    zIndex: 0, 
  },
}));

const CustomStepIconRoot = styled('div')<{
  ownerState: { active?: boolean; completed?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: ownerState.completed ? COLORS.apronBrown : COLORS.inactive,
  color: '#ffffff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  fontSize: '1.25rem',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  zIndex: 1,
  ...(ownerState.active && {
    backgroundColor: COLORS.apronBrown,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
}));

function CustomStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  return (
    <CustomStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? <Check style={{ color: '#ffffff' }} /> : <div>{props.icon}</div>}
    </CustomStepIconRoot>
  );
}

const HorizontalLinearStepper = () => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Container>
      <Box sx={{ width: '100%' }}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          connector={<CustomConnector />}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel StepIconComponent={CustomStepIcon}>
                <Typography
                  style={{
                    color: activeStep === index || activeStep > index ? '#ffffff' : COLORS.inactive,
                  }}
                >
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }} style={{ color: '#ffffff' }}>
            <DialogContainer 
              step={'Fertig'}
              heading={'Bewerbung erfolgreich abgeschlossen'}
              content={'Vielen Dank für dein Interesse an den Eckenmoorhexen! Wir werden deine Unterlagen sorgfältig prüfen und uns zeitnah bei dir melden. In der Zwischenzeit kannst du gespannt bleiben und dich schon ein wenig auf das Vereinsleben freuen. Wir sind gespannt darauf, dich möglicherweise bald in unserer Gemeinschaft willkommen zu heißen!'}
              {...steps}
              onBack={handleBack} 
              isLastStep={activeStep === steps.length - 1} 
              isFinished={true}
                />            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {DialogContainerProps.map((props, index) => (
              activeStep === index && (
                <DialogContainer 
                    {...props} 
                    onBack={handleBack} 
                    onNext={handleNext} 
                    isLastStep={activeStep === steps.length - 1}
                    isFinished={activeStep === steps.length}
                    isFirstStep = {activeStep === 0} 
                />
              )
          ))}

          </React.Fragment>
        )}
      </Box>
    </Container>
  );
}

export default HorizontalLinearStepper;
